const parsedUpdatedAtIntervalMs = Number(
  process.env.RESERVATION_UPDATED_AT_INTERVAL_MS
);

export default {
  updatedAtIntervalMs:
    parsedUpdatedAtIntervalMs > 0 ? parsedUpdatedAtIntervalMs : 60000
};
